(function () {
  'use strict';

  if (window.__lara11ClerkPrivacyLoaded) {
    return;
  }

  window.__lara11ClerkPrivacyLoaded = true;

  var state = {
    ready: false,
    trackingAllowed: false,
    visitor: null
  };

  function getCustomerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function isTrackingAllowed(customerPrivacy) {
    if (!customerPrivacy
      || typeof customerPrivacy.analyticsProcessingAllowed !== 'function'
      || typeof customerPrivacy.preferencesProcessingAllowed !== 'function') {
      return false;
    }

    try {
      // Clerk uses the visitor for both interaction analytics and personalised
      // recommendations, so both Shopify purposes must be allowed.
      return customerPrivacy.analyticsProcessingAllowed()
        && customerPrivacy.preferencesProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function applyState() {
    var customerPrivacy = getCustomerPrivacy();

    state.ready = Boolean(customerPrivacy);
    state.trackingAllowed = isTrackingAllowed(customerPrivacy);
    state.visitor = state.trackingAllowed ? 'auto' : null;

    if (typeof window.Clerk === 'function') {
      window.Clerk('config', 'visitor', state.visitor);
    }

    document.dispatchEvent(new CustomEvent('lara11:clerk-privacy-change', {
      detail: {
        ready: state.ready,
        trackingAllowed: state.trackingAllowed
      }
    }));
  }

  window.Lara11ClerkPrivacy = {
    getVisitor: function () {
      return state.visitor;
    },
    isReady: function () {
      return state.ready;
    },
    isTrackingAllowed: function () {
      return state.trackingAllowed;
    },
    refresh: applyState
  };

  document.addEventListener('visitorConsentCollected', applyState);

  if (getCustomerPrivacy()) {
    applyState();
    return;
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.2'
      }
    ], function (error) {
      if (!error) {
        applyState();
      }
    });
  }
})();
